import styled from 'styled-components';

const DetailContainerStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export default DetailContainerStyled;
